import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getWorkflowUsage } from "../../api";
import * as route from "../../api/routes";
import { WorkflowUsage } from "./types";

/**
 * Operations and active scenarios against the plan. A null limit means the plan
 * has no automations at all (the cabinet enforces these fail-closed).
 */
const UsageBar = ({ reloadKey = 0 }: { reloadKey?: number }) => {
    const { t } = useTranslation(['workflow']);
    const [usage, setUsage] = useState<WorkflowUsage | null>(null);

    useEffect(() => {
        getWorkflowUsage().then((r: any) => setUsage(r.usage)).catch(() => setUsage(null));
    }, [reloadKey]);

    if (!usage) {
        return null;
    }

    if (usage.operations.limit === null || usage.activeScenarios.limit === null) {
        return (
            <div className="alert alert-warning d-flex align-items-center gap-2">
                <i className="ri-lock-line" />
                <span>{t('workflow:planHasNoAutomation')}</span>
                <Link to={route.SALE_PLANS} className="btn btn-sm btn-warning ms-auto">{t('workflow:upgradePlan')}</Link>
            </div>
        );
    }

    const percent = Math.min(100, Math.round((usage.operations.used / Math.max(1, usage.operations.limit)) * 100));

    return (
        <div className="card mb-3">
            <div className="card-body py-2 d-flex flex-wrap align-items-center gap-4">
                <div className="flex-grow-1" style={{ minWidth: 240 }}>
                    <div className="d-flex justify-content-between small mb-1">
                        <span>{t('workflow:operationsThisPeriod')}</span>
                        <span className="fw-semibold">{usage.operations.used.toLocaleString()} / {usage.operations.limit.toLocaleString()}</span>
                    </div>
                    <div className="progress" style={{ height: 6 }}>
                        <div className={"progress-bar " + (percent >= 90 ? 'bg-danger' : percent >= 70 ? 'bg-warning' : 'bg-success')} style={{ width: percent + '%' }} />
                    </div>
                </div>
                <div className="small">
                    {t('workflow:activeScenarios')}: <span className="fw-semibold">{usage.activeScenarios.used} / {usage.activeScenarios.limit}</span>
                </div>
                <div className="small text-muted">{t('workflow:minInterval', { minutes: usage.minIntervalMinutes })}</div>
            </div>
        </div>
    );
};

export default UsageBar;
